<div class="button-bar">
    <button
        class="default button-padding"
        (click)="openAddLicensePopup()"
        i18n="@@license.list.add-new-activation-key.button"
        test-id="license.list.add-new-activation-key.button"
        has-privileges="PlantLicenseManage"
    >Add new Controller License</button>
</div>
<!-- plantFeatureLicenseId, activationKey, activationId, createDate -->
<clx-data-grid
    [data]="source"
    [showFilter]="false"
    [showGroupPanel]="false"
    [showColumnChooser]="false"
    [selection]="{ mode : 'none' }"
    [remoteOperations]="remoteOperations"
    [showHeaderFilter]="false"
    [showSearchPanel]="true"
    [version]="1"
    id="licens-list"
    test-id="license.list.datdagrid"
>

    <clx-grid-column
        dataField="activationKey"
        dataType="string"
        i18n-caption="@@license.list.column.caption.activationkey"
        caption="Activation key"
        [allowSearch]="true"
    >
        <ng-template let-data="item">
            <a routerLink="/Administration/LicenseManager/{{data.data.plantFeatureLicenseId}}" title="{{data.displayValue}}">{{data.displayValue}}</a>
        </ng-template>
    </clx-grid-column>

    <clx-grid-column
        dataField="createDate"
        dataType="string"
        i18n-caption="@@license.list.column.caption.createdate"
        caption="Create date"
        [allowSorting]="true"
        [allowSearch]="false"
    >
        <ng-template let-data="item">
            {{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}
        </ng-template>
    </clx-grid-column>

    <clx-grid-column
        *ngIf="hasPrivSystemAdministrator === true"
        dataField="tenantName"
        dataType="string"
        i18n-caption="@@license.list.column.caption.tenantname"
        caption="Tenant"
        [allowSearch]="true"
    >
    </clx-grid-column>

    <clx-grid-column
        *ngIf="hasPrivSystemAdministrator === true"
        dataField="createUser"
        dataType="string"
        i18n-caption="@@license.list.column.caption.createUser"
        caption="Created by"
        [allowSearch]="true"
    >
    </clx-grid-column>
</clx-data-grid>

<dx-popup
    [showTitle]="true"
    i18n-title="@@license.addkey.popup.title"
    title="Create Controller License File"
    [(visible)]="isPopUpVisible"
    [resizeEnabled]="true"
    [width]="530"
    height="auto"
>
    <div *dxTemplate="let data of 'content'">
        <messages name="popup-messages"></messages>
        <loader target=".dx-overlay-content" [show]="showLoader"></loader>
        <clx-form [disableChangeChecking]="true" *ngIf="isPopUpVisible">
            <clx-row>
                <clx-label i18n="@@license.addkey.popup.activation-key.label">Controller Activation Key</clx-label>
                <clx-input name="licenskey" [(ngModel)]="newLicenseKey" test-id="license.addkey.popup.licenskey.input">
                    <clx-validation type="uuid"></clx-validation>
                </clx-input>
            </clx-row>
            <clx-row>
                <clx-label i18n="@@license.addkey.popup.activation-id.label">License Activation ID</clx-label>
                <clx-input name="activationid" [(ngModel)]="newActivationId" test-id="license.addkey.popup.activationid.input">
                </clx-input>
            </clx-row>
            <clx-row type="buttons">
                <clx-button
                    (onClick)="validateActivationId()"
                    [disabled]="(showLoader || (!newActivationId || !newLicenseKey)) ? true : null"
                    test-id="license.add-activation-id.popup.validate-id.button"
                    i18n="@@license.addkey.popup.validate-activation-id.button"
                >Validate License</clx-button>
                <clx-button
                    (onClick)="addLicenseKey()"
                    [disabled]="(showLoader || (addLicensButtonDisabled || (!isActivationIdValid && newActivationId))) ? true : null" 
                    test-id="license.addkey.popup.add-activation-key.button"
                    i18n="@@license.addkey.popup.add-activation-key.button"
                >Create License</clx-button>
            </clx-row>
        </clx-form>
    </div>
</dx-popup>